<template>

    <div>
        <!--
        <lang labelKey="PIM-SETTINGS-TAB-SORTIMENT"></lang>
        <lang labelKey="PIM-SETTINGS-TAB-SHOPIX"></lang>
    -->
      <div class="section-header"><lang labelKey="PIM-SETTINGS-SORTIMENT-CAT_TREE_UPLOAD"></lang></div>

      <div class="section">
          <!-- acceptedFiles=".zip" -->
          <vue-dropzone
              ref="vueDropzone"
              id="vueDropzone"
              url= "fileProcessing/upload?preset=catTree"
              :maxFiles="1"
              acceptedFiles=".xlsx"
              dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Dokument hochladen"
              v-on:vdropzone-success="dzSuccess"
              v-on:vdropzone-mounted="dzInit"
              dzClass="default dzSingle">
          </vue-dropzone>
      </div>

      <div class="section-header"><lang labelKey="PIM-SETTINGS-SORTIMENT-UPLOAD_HISTORY"></lang></div>
      <div class="section">

        <loading-indicator :loading="isLoading"></loading-indicator>

        <template v-if="!isLoading">

            <div class="columns" v-for="entry in entries" :key="entry.created">

                <div class="column">
                    {{ entry.status }}
                </div>

                <div class="column is-narrow">
                    {{ formatDate(entry.created) }}
                </div>

            </div>

        </template>

      </div>


        <!-- MODAL -->
        <modal
            width="640"
            transition="fadeDown"
            cancel-text="Abbrechen"
            title="Upload"
            :show-ok="false"
            :backdrop-closable="false"
            :is-show="showModal"
            @close="closeModal">

                <template v-if="modal.isLoading">
                    <loading-indicator></loading-indicator>
                </template>

                <template v-else>

                    <template v-if="progressStatus == null">

                        <loading-indicator-small></loading-indicator-small>

                    </template>

                    <template v-else>

                        <template v-if="progressStatus.status != 'Finished'">

                            <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                            <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                        </template>

                        <template v-else>

                            <div class="notification is-success">
                                <span class="icon"><i class="fa fa-check"></i></span>
                                <span>Datei wurde erfolgreich hochgeladen</span>
                            </div>

                            <div slot="footer">
                                <span :class="['button', { 'is-disabled': modal.isSaving || modal.isLoading }]" @click="closeModal">schließen</span>
                            </div>

                        </template>


                        <!--
                        <div slot="footer">

                            <span :class="['button', { 'is-disabled': modal.isSaving || modal.isLoading }]" @click="closeModal">abbrechen</span>
                            <span :class="['button is-success', { 'is-loading': modal.isSaving  }, { 'is-disabled': modal.isLoading }]" @click="batchIt">speichern</span>

                        </div>
                        -->


                    </template>

                </template>

        </modal>


    </div>

</template>


<script>
import vue2Dropzone from '../../utils/dropzoneWrapper'

export default {

    components: {
        vueDropzone: vue2Dropzone,
    },

    data() {

        return {
            isLoading: false,
            entries: null,

            refreshIntervalId: null,
            progressStatus: null,

            showModal: false,

            modal: {
                isLoading: false,
                isSaving: false,
            }
        }
    },

    created() {

        this.init();

    },

    methods: {

        init() {

            this.isLoading = true;

            // return this.axios.get(this.$config.api + 'taskLog?filters[task]=29&showMetafields=1').then(res => {
            return this.axios.get(this.$config.api + 'taskLog?filters[task]=29&showMetafields=1&orderBy=created%20DESC').then(res => {
                this.entries = res.data.taskLog;
                this.isLoading = false;
            })

        },


        dzSuccess(file, response) {

            var self = this;
            this.modal.isLoading = false;
            this.modal.isSaving = false;

            this.showModal = true;

            this.$refs.vueDropzone.$children[0].removeAllFiles();
            let taskLogId = response.taskLogId;

            self.refreshIntervalId = setInterval(function() {

                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                    .then(response => {

                        self.progressStatus = response.data;

                        if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                            clearInterval(self.refreshIntervalId);

                            this.init().then(res => {

                                // self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                // self.closeModal();

                            })

                            /*
                            self.axios.get(self.$config.api + 'newsletter/subscribers?site='+self.siteId)
                                .then(function(response) {
                                    self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                    self.recipients.data = response.data;
                                    self.closeModal();
                                })
                            */

                        }

                    });

            }.bind(self), 1000);


            setTimeout(function() {

                clearInterval(self.refreshIntervalId);
                self.showModal = false;

            }, 1000000);

        },

        closeModal() {

            // in case we've running an interval
            clearInterval(this.refreshIntervalId);

            this.progressStatus = null;

            this.modal.isSaving = false;
            this.showModal = false;

        },

    }


}

</script>

<style lang="scss" scoped>

    .section {
        max-width: 640px;
    }
    .columns {
        .column {
            padding-top: 6px;
            padding-bottom: 6px;
        }
    }

    .notification {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 320px;
        margin: 0 auto;
        text-align: center;

        .icon {
            margin-right: 8px;
        }
    }
</style>
